// svg is editted version of the offcial site: https://wantedlyinc.com/ja/brand_assets
import React from 'react'
import { colors } from 'plume-ui'

type Props = {
  color?: string
  size?: number
}

export const Wantedly: React.FC<Props> = ({
  color = colors.black10,
  size = 25,
}) => {
  return (
    <svg
      version="1.1"
      id="レイヤー_1"
      x="0px"
      y="0px"
      viewBox="0 0 900 900"
      // wantedly icon is subtly smaller than other icons
      width={`${size * 1.12}px`}
      height={`${size * 1.12}px`}
      color={color}
    >
      <polygon
        points="100,208.6 200,208.6 350,570.7 400,450 300,208.6 400,208.6 450,329.3 500,208.6 600,208.6 500,450 
	550,570.7 700,208.6 800,208.6 600,691.4 500,691.4 450,570.7 400,691.4 300,691.4 "
      />
    </svg>
  )
}
